export default [
  {
    path: "/accounting/accounts",
    name: "accounting.accounts.list",
    component: () =>
      import("@/view/pages/accounting/accounts/AccountList.vue"),
  },
];
